import { environment } from '../../environments/environment';
import * as Sentry from '@sentry/angular';


export function initSentry(): void {
  Sentry.init({
    dsn: 'https://4cfdbed475eb4d629917b0279b079db0@o34807.ingest.sentry.io/4505469730553856',
    // TryCatch has to be configured to disable XMLHttpRequest wrapping, as we are going to handle
    // http module exceptions manually in Angular ErrorHandler, and we don't want it to capture the same error twice.
    integrations: [
      Sentry.browserApiErrorsIntegration({
        eventTarget: false,
        requestAnimationFrame: false,
        setInterval: false,
        setTimeout: false,
        XMLHttpRequest: false
      }),
    ],
    environment: environment.name,
    release: environment.release && `app-concierge-web@${environment.release}`
  });
}
